import React, { HTMLAttributes } from 'react';

import { TabsProvider, TabsProviderProps } from '../context/TabsContext';

type LbTabsProps = TabsProviderProps & HTMLAttributes<HTMLDivElement>;

/**
 * Groups the tabs and the corresponding panels.
 * Renders a `<div>` element.
 */
const LbTabs = ({
  children,
  defaultValue,
  value,
  onValueChange,
  ...props
}: LbTabsProps) => {
  return (
    <TabsProvider defaultValue={defaultValue} value={value} onValueChange={onValueChange}>
      <div {...props}>{children}</div>
    </TabsProvider>
  );
};

export { LbTabs, LbTabsProps };
